module.exports = __webpack_public_path__ + "img/p1-green.4fda9471.png";